<template>
  <v-card outlined class="rounded-lg stat-card pa-4" elevation="0">
    <div class="d-flex align-center">
      <v-avatar size="48" class="stat-card-icon mr-3" rounded>
        <v-icon color="white">{{icon}}</v-icon>
      </v-avatar>
      <div>
        <div class="text-h6 font-weight-bold stat-card-count">{{count}}</div>
        <div class="text-caption stat-card-title">{{title}}</div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
    name: 'StatCard',
    props: [
        'count', 'title', 'icon'
    ]
}
</script>

<style scoped>
.stat-card {
    border: 1px solid #ECEFF7;
    height: 100%;
}
.stat-card-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.stat-card-count {
    color: #1E3C72;
    line-height: 1.2;
}
.stat-card-title {
    color: #607D8B;
    font-weight: 600;
}
</style>
